define(
    'viewmodels/secured/people/tabs/teams/teams',[
        "durandal/app",
        "viewmodels/secured/people/context",
        "viewmodels/ViewModelNotification",
        "providers/dataprovider",
        "i19n!i19n/strings",
        "services/service.dialog"
    ],
    function (app, ctx, ViewModelNotification, dataProvider, i19n, dialogService) {

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            $grid: null,
            grid: null,
            resultCount: ko.observable(0),
            addRow: function () {
                if (this.grid)
                    this.grid.addRow();
            },
            listTeams: ko.observable(),
            tellReloadSubscription: null,

            isAdmin: ko.observable(false),

            perWin: {
                formId: 'Team',
                fid: null,
                windowtitle: '',
                title: '',
                show: {},
                addPersons: function (data) {
                    data = $.map(data, function (value, key) {
                        return { id: value };
                    });

                    dataProvider
                    .teams
                    .addPeopleToTeam({ id: vm.perWin.fid, persons: data })
                    .done(function (result) {
                        vm.refresh(true);

                        ctx.tellReload("person.team");

                        vm.notify('success', i19n.to.peopleaddedtoteam);
                    })
                    .fail(function (result) {
                        result.stopPropagation = true;

                        vm.notify(result.error);
                    });
                }
            }
        });

        vm.activate = function () {
            var self = this;

            self.isAdmin(vm.session.role == 3 || vm.session.role == 4 ? true : false);
        };
        vm.attached = function () {
            var self = this;

            self.$grid = $("#teams-grid");

            $("#team-search-input").off();
            $("#team-search-input").on("keyup", _.debounce(function () { filter.call(this, self.grid); }, 400));

            $(window).off("resize", _.debounce(resizeGrid, 250));
            $(window).on("resize", _.debounce(resizeGrid, 250));

            self.loadData()
            .done(function () {
                buildKendoGrid();
            })
            .fail(function (e) {
                console.log(e);
            });

            function buildKendoGrid() {
                self.notifications([]);

                var columns = [
                    { field: "id", hidden: true },
                    { field: "name", title: i19n.to.name, width: 190 },
                    { field: "description", title: i19n.to.description },
                    { field: "isGuest", title: i19n.to.guest, hidden: true }
                ];

                if (self.isAdmin()) {
                    var cmd = {
                        command: [
                            { name: "addpeople", click: addPeopleClick, template: "<a href=\"\\#\" class=\"k-button k-button-icontext k-grid-addpeople\"><span class=\"k-icon k-add\"></span>&nbsp;<span>" + i19n.to.addpeople + "</span></a>" },
                            { name: "edit", text: i19n.to.edit },
                            { name: "destroy", text: i19n.to.delete }
                        ],
                        title: "&nbsp;",
                        width: 300
                    };

                    columns.push(cmd);
                }

                self.grid = self.$grid.kendoGrid({
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    selectable: "row",
                    reorderable: true,
                    sortable: true,
                    detailInit: detailInit,
                    columns: columns,
                    scrollable: {
                        virtual: true
                    },
                    editable: {
                        mode: "popup"
                    },
                    cancel: self.clearNotifications,
                    edit: function (e) {

                        //hide id
                        e.container.find(".k-edit-label:first").hide();
                        e.container.find("input[name=id]").hide();

                        if (e.model.id.length == 0) {
                            $(".k-window-title").text("Add Team");
                        } else {
                            $(".k-window-title").text("Edit Team");
                            //guest team cannot be updated to non guest as per james
                            e.container.find("input[name=isGuest]").on('click', function (e) { e.preventDefault(); });
                        }

                        self.clearNotifications();

                    },
                    remove: self.clearNotifications,
                    save: self.clearNotifications

                }).data("kendoGrid");
            };
            function getKendoGridDataSource() {
                var schema = {
                    model: {
                        id: "id",
                        fields: {
                            id: { type: "string" },
                            name: { type: "string", validation: { required: true } },
                            description: { type: "string", validation: { required: true } },
                            isGuest: { type: "boolean", validation: { required: false } },
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(self.listTeams());

                            resizeGrid();
                        },
                        update: function (callbacks) {
                            dataProvider
                                .teams
                                .updateTeam(callbacks.data)
                                .done(function (result) {
                                    self.notify('success', callbacks.data.name + ' ' + i19n.to.updated);

                                    callbacks.success();

                                    ctx.tellReload("person.team");
                                })
                                .fail(function (result) {
                                    result.stopPropagation = true;

                                    self.notify(result.error);

                                    callbacks.error(result.error);
                                });
                        },
                        create: function (callbacks) {
                            dataProvider
                                .teams
                                .addTeam(callbacks.data)
                                .done(function (result) {
                                    self.notify('success', callbacks.data.name + ' ' + i19n.to.teamadded);

                                    callbacks.data["id"] = result;
                                    callbacks.success(callbacks.data);

                                    ctx.tellReload("person.team");
                                })
                                .fail(function (result) {
                                    result.stopPropagation = true;

                                    self.notify(result.error);

                                    callbacks.error(result.error);
                                });
                        },
                        destroy: function (callbacks) {
                            var dialogoptions = { ok: { label: 'Yes', message: '' }, cancel: { label: 'No', message: '' } };

                            dialogService.showMessageBox(i19n.to.confirmdelete, i19n.to.delete + ' ' + callbacks.data.name + ' ?', _.toArray(dialogoptions))
                            .then(function (action) {
                                if (action == dialogoptions.cancel) {
                                    self.grid.cancelChanges();
                                }
                                if (action == dialogoptions.ok) {
                                    dataProvider
                                    .teams
                                    .deleteTeam(callbacks.data.id)
                                    .done(function (result) {
                                        self.notify('success', callbacks.data.name + ' ' + i19n.to.teamdeleted);

                                        callbacks.success();

                                        ctx.tellReload("person.team");
                                    })
                                    .fail(function (e) {
                                        self.grid.cancelChanges();

                                        e.stopPropagation = true;

                                        self.notify(e.error);

                                        callbacks.error(e.error);

                                        console.error(e);
                                    });
                                }
                            });
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });
            }
            function detailInit(e) {
                var columns = [
                            { field: "id", hidden: true },
                            { field: "teamId", hidden: true },
                            { field: "displayName", title: i19n.to.displayname, width: 180 },
                            { field: "emailAddress", title: i19n.to.email }
                ];

                if (self.isAdmin()) {
                    var cmd = {
                        command: [
                            { name: "destroy", text: i19n.to.remove }
                        ],
                        title: "&nbsp;",
                        width: "100px"
                    };

                    columns.push(cmd);
                }

                $("<div/>")
                .appendTo(e.detailCell).kendoGrid({
                    dataSource: getKendoGridDataSourcePersons(e.data.id),
                    editable: {
                        mode: "popup"
                    },
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    scrollable: {
                        virtual: true
                    }
                });

                function getKendoGridDataSourcePersons(teamId) {
                    var schema = {
                        model: {
                            id: "id",
                            fields: {
                                id: { type: "string" },
                                teamId: { type: "string" },
                                userName: { type: "string" },
                                displayName: { type: "string" },
                                emailAddress: { type: "string" }
                            }
                        }
                    };

                    return new kendo.data.DataSource({
                        transport: {
                            read: function (callbacks) {                                
                                var d = _.map(e.data.people, function (itm) {
                                    return {
                                        id: itm.id,
                                        teamId: teamId,
                                        userName: itm.userName,
                                        displayName: itm.displayName,
                                        emailAddress: itm.emailAddress
                                    };
                                });

                                callbacks.success(d);
                            },
                            update: function (callbacks) {
                            },
                            create: function (callbacks) {
                            },
                            destroy: function (callbacks) {
                                var dialogoptions = { ok: { label: 'Yes', message: '' }, cancel: { label: 'No', message: '' } };

                                dialogService.showMessageBox(i19n.to.confirmremove, String.format(i19n.to.remove_fromteam, callbacks.data.displayName) + ' ?', _.toArray(dialogoptions))
                                .then(function (action) {
                                    if (action == dialogoptions.cancel) {
                                        self.grid.cancelChanges();
                                    }
                                    if (action == dialogoptions.ok) {
                                        var rec = {
                                            teamId: callbacks.data.teamId,
                                            personId: callbacks.data.id
                                        };

                                        dataProvider.teams
                                        .removePeopleFromTeam(rec)
                                        .done(function (result) {
                                            e.data.people = _.without(e.data.people, _.findWhere(e.data.people, { id: callbacks.data.id }));
                                            self.notify('success', String.format(i19n.to.remove_fromteam, callbacks.data.displayName));

                                            callbacks.success();

                                            ctx.tellReload("person.team");
                                        })
                                        .fail(function (e) {
                                            self.grid.cancelChanges();

                                            e.stopPropagation = true;

                                            self.notify(e.error);

                                            callbacks.error(e.error);

                                            console.error(e);
                                        });
                                    }
                                });
                            }
                        },
                        schema: schema,
                        pageSize: 999
                    });
                }
            };
            function addPeopleClick(e) {
                e.preventDefault();

                var data = this.dataItem($(e.currentTarget).closest("tr"));

                self.perWin.fid = data.id;
                self.perWin.title = data.name;

                self.perWin.show();
            }
            function resizeGrid() {
                if (!self.$grid)
                    return;

                var tbh = $("#teams-grid-toolbar", "#content-teams").outerHeight(); tbh = tbh == 0 ? 51 : tbh;
                var newGridHeight = $("#content-people").outerHeight()
                    - $(".page-header", "#content-people").outerHeight()
                    - tbh
                    - 110;

                self.$grid.height(newGridHeight);
                self.$grid.data("kendoGrid").resize();
            }

            subscribe();
        };
        vm.refresh = function (newValue) {
            var self = this;

            if (self.grid == null)
                return;

            if (newValue) {
                self.loadData()
                .done(function () {
                    self.grid.dataSource.read();
                })
                .fail(function (e) {
                    console.log(e);
                });
            }
        };
        vm.isBusy = ko.computed(function () {
            return false;
        });
        vm.loadData = function () {
            var self = this,
                d = $.Deferred();

            ctx
            .loadForTeam()
            .done(function () {
                self.listTeams(ctx.teams());

                self.resultCount(self.listTeams().length);

                d.resolve();
            })
            .fail(function (e) {
                d.reject('error loading in teams module : ' + e);
                console.log('error loading in teams module : ' + e);
            });

            return d.promise();
        };

        return vm;

        function filter(kendoGrid) {
            if (!kendoGrid)
                return;

            var value = this.value;

            //var filteredColumns = _.filter(kendoGrid.options.columns, function (column) { return column.field; });
            var filteredColumns = [{ field: "name" }, { field: "description" }];
            var filters = _.map(filteredColumns, function (column) {
                return {
                    field: column.field,
                    operator: function (item, val) {
                        if (!(typeof column.command == 'undefined'))
                            return false;

                        if (val == null || val.trim().length == 0)
                            return true;

                        var searchText = '';

                        if (item != null) {
                            searchText = item.toString();
                        }

                        val = val.toLowerCase();
                        searchText = searchText.toLowerCase();

                        return item != null && searchText.indexOf(val) >= 0;

                    }, value: value //String.format("'{0}'", value)
                };
            });

            kendoGrid.dataSource.filter({
                logic: "or",
                filters: filters
            });
        }
        function subscribe() {
            if (vm.tellReloadSubscription != null)
                vm.tellReloadSubscription.dispose();

            vm.tellReloadSubscription = ctx.tellReload.subscribe(function (n) {
                if (n == "team.person") {
                    vm.refresh(true);
                }
            });
        }
    });






